export const symbolForAsyncComputedPropsFromHost = Symbol.for("tpl.asyncComputedPropsFromHost");
export const symbolForTplStateStoreId = Symbol.for("tpl.stateStoreId");
export const symbolForTPlExternalForEachItem = Symbol.for("tpl.externalForEachItem");
export const symbolForTPlExternalForEachIndex = Symbol.for("tpl.externalForEachIndex");
export const symbolForTPlExternalForEachSize = Symbol.for("tpl.externalForEachSize");
//# sourceMappingURL=constants.js.map